export default [
  {
    path: '/setting/brand',
    meta: {
      title: '品牌方管理',
    },
    component: () => import('@/views/setting/Brand'),
  },
  {
    path: '/setting/brand-user',
    meta: {
      title: '品牌方账户',
    },
    component: () => import('@/views/setting/brand-user'),
  },
  {
    path: '/setting/decorate-company',
    meta: {
      title: '装修公司管理',
    },
    component: () =>
      import('@/views/setting/decorate-company-managment/index'),
  },
  {
    path: '/setting/supplier',
    meta: {
      title: '供货商管理',
    },
    component: () => import('@/views/setting/Supplier'),
  },

]